import React, { Component } from 'react';
import { getCurrentResource } from '../../util/tools';
import PlainFullDescription from '../../components/fulldescription/PlainFullDescription';
import styles from '../../components/fulldescription/FullDescription.module.css';
import { FORM_CONFIRMATION_FT } from '../../util/consts/forms';
import { CLASS_CONFIRMATION } from '../../util/consts/classes';

class ConfirmationPage extends Component {

	constructor(props) {
		super(props);
		this.resource = getCurrentResource().pages.plain.Confirmation;
		this.plainInfo = {
			app: props.app,
			page: this,
			class: CLASS_CONFIRMATION,
			instanceModelId: FORM_CONFIRMATION_FT,
			instanceId: this.props.match.params.id,
			param: {}
		};
	}

	render() {
		return (
			<React.Fragment>
				<div className={styles.divPlainTitle}>
					{this.resource.title}
				</div>
				<PlainFullDescription plain={this.plainInfo} />
			</React.Fragment>
		)
	}
}

export default ConfirmationPage;
